import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { siteUrls } from '../../constants/urls.const';

@Injectable()
export class FeatureTogglingService {
  currentEnv: string = '';

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.checkCurrentEnv();
  }

  checkCurrentEnv(): void {
    const locationHref = this.document.location.href;
    for (const key in siteUrls) {
      const url: string = siteUrls[key];
      if (locationHref.includes(url)) {
        this.currentEnv = key;
      }
    }
  }

  isFeatureAllowed(
    feature: string,
    features: Record<string, string[]>
  ): boolean {
    if (this.currentEnv) {
      return features[this.currentEnv].indexOf(feature) >= 0;
    }
    return false;
  }
}
